import {
  ArrowLeftOutlined,
  UserOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons'

import { ReactComponent as dashboardSvg } from '../assets/images/dashboard.svg'
import { ReactComponent as initialSetup } from '../assets/images/initial_setup.svg'
import { ReactComponent as myDevice } from '../assets/images/my_device.svg'
import { ReactComponent as deviceSettingSvg } from '../assets/images/device-setings.svg'
import { ReactComponent as myApp } from '../assets/images/my_app.svg'
import { ReactComponent as androidUpdates } from '../assets/images/android_updates.svg'
import { ReactComponent as licensing } from '../assets/images/licensing.svg'
import { ReactComponent as myServices } from '../assets/images/my_services.svg'
import { ReactComponent as designStudioIconSvg } from '../assets/images/design_studio_icon.svg'
import { ReactComponent as deviceUsers } from '../assets/images/device_users.svg'
import { ReactComponent as rolesSvg } from '../assets/images/roles.svg'
import { ReactComponent as supportTools } from '../assets/images/supportTools.svg'
import { ReactComponent as rxLogger } from '../assets/images/rxLogger.svg'
import { ReactComponent as wirelessInsightsIcon } from '../views/wi-views/utils/icons/wi-icon.svg'
import { ReactComponent as profileDependencySvg } from '../assets/images/profile-dependency.svg'
import { ReactComponent as contentManagement } from '../assets/images/akamai/ContentManagement/contentManagement_icon.svg'
import { ReactComponent as schedule } from '../assets/images/akamai/ContentManagement/schedule_icon.svg'
import { ReactComponent as myContent } from '../assets/images/akamai/ContentManagement/myContent_icon.svg'
import { ReactComponent as recycle } from '../assets/images/akamai/ContentManagement/recycle_icon.svg'
import { ReactComponent as MyFile } from '../assets/images/akamai/MyFile/myFile_icon.svg'       // EDCL-350 (RS)

const dashboardNavTree = [
  {
    key: 'home',
    path: '/app/home',
    title: 'Dashboard',
    iconImage: dashboardSvg,
    breadcrumb: false,
    submenu: [],
  },

  {
    key: 'initialSetupNew',
    path: '/app/initialSetupNew',
    title: 'New Device Setup',
    iconImage: initialSetup,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'myDevice',
    path: '/app/myDevice',
    title: 'My Devices',
    iconImage: myDevice,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'deviceUsers',
    path: '/app/deviceUsers',
    title: 'Device Users',
    iconImage: deviceUsers,
    breadcrumb: false,
    submenu: [],
  },
 {
    key: 'deviceSettings',
    path: '/app/deviceSettings',
    title: 'Device Settings',
    iconImage: deviceSettingSvg,
    breadcrumb: false,
    submenu: [],
  },
  // EDCL-350 (RS) -->
  {
    key: 'myFiles',
    path: '/app/myFiles',
    title: 'My Files',
    iconImage: MyFile,
    breadcrumb: false,
    submenu: [],
  },
  // <-- EDCL-350 (RS)
  //content management code starts
  {
    key: 'ContentManagement',
    path: '',
    title: 'Content Management',
    iconImage: contentManagement,
    breadcrumb: false,
    submenu: [
      {
        key: 'myContent',
        path: '/app/contentManagement/myContent',
        title: 'My Content',
        iconImage: myContent,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'schedule',
        path: '/app/contentManagement/schedule',
        title: 'Schedule',
        iconImage: schedule,
        breadcrumb: false,
        submenu: []
      },
      {
        key: 'recycle',
        path: '/app/contentManagement/recycle',
        title: 'Recycle Content',
        iconImage: recycle,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  //ends
  {
    key: 'profileDependency',
    path: '/app/profileDeployments',
    title: 'Profile Deployments',
    iconImage: profileDependencySvg,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'myApps',
    path: '/app/myApps',
    title: 'My Apps',
    iconImage: myApp,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'designStudio',
    path: '/app/designStudio',
    title: 'Design Studio',
    iconImage: designStudioIconSvg,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'androidUpdates',
    path: '/app/androidUpdates',
    title: 'Android Updates',
    iconImage: androidUpdates,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'licensing',
    path: '/app/licensing',
    title: 'Licensing',
    iconImage: licensing,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'supportTools',
    path: '',
    title: 'Support Tools',
    iconImage: supportTools,
    breadcrumb: false,
    submenu: [
      {
        key: 'remoteRxLogger',
        path: '/app/supportTools/remoteRxLogger',
        title: 'Remote Rxlogger',
        iconImage: rxLogger,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'wirelessInsights',
        path: '/app/supportTools/wirelessInsights',
        title: 'Wireless Insights',
        iconImage: wirelessInsightsIcon,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
]

const userDashboardNavTree = [
  {
    key: 'appDashboard',
    path: '/app/home',
    title: 'Back',
    icon: ArrowLeftOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'myProfile',
    path: '/user/myProfile',
    title: 'My Profile',
    icon: UserOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'myServices',
    path: '/user/myServices',
    title: 'My Services',
    iconImage: myServices,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'roleManagement',
    path: '/user/roleManagement',
    title: 'Roles',
    iconImage: rolesSvg,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'userManagement',
    path: '/user/userManagement',
    title: 'Users',
    icon: UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [],
  },
]

const navigationConfig = (path) => {
  return path && path.includes('user/') ? [...userDashboardNavTree] : [...dashboardNavTree]
}

export default navigationConfig
